const sanitizeHtmlString = (input) => {
  if (typeof input !== 'string') return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(input, 'text/html');

  doc.querySelectorAll('script, iframe, object, embed, link[rel="import"]').forEach((node) => {
    node.remove();
  });

  doc.querySelectorAll('*').forEach((node) => {
    Array.from(node.attributes).forEach((attr) => {
      const attrName = attr.name.toLowerCase();
      const attrValue = (attr.value || '').trim().toLowerCase();
      if (attrName.startsWith('on')) node.removeAttribute(attr.name);
      if ((attrName === 'src' || attrName === 'href') && attrValue.startsWith('javascript:')) {
        node.removeAttribute(attr.name);
      }
    });
  });

  return doc.body.innerHTML;
};

const sanitizeScriptUrl = (input) => {
  if (typeof input !== 'string') return '';

  try {
    const url = new URL(input, window.location.origin);
    if (url.origin !== window.location.origin) {
      const allowedScriptHosts = new Set([
        'www.googletagmanager.com',
        'www.google-analytics.com',
      ]);
      if (!allowedScriptHosts.has(url.hostname)) {
        throw new Error('Cross-origin script URL blocked by Trusted Types policy.');
      }
    }
    return url.toString();
  } catch {
    return '';
  }
};

export const initTrustedTypes = () => {
  if (typeof window === 'undefined' || !window.trustedTypes) return;

  try {
    window.trustedTypes.createPolicy('default', {
      createHTML: sanitizeHtmlString,
      createScript: () => '',
      createScriptURL: sanitizeScriptUrl,
    });
  } catch {
    // Policy may already exist in HMR or repeated inits.
  }

  try {
    window.trustedTypes.createPolicy('app-policy', {
      createHTML: sanitizeHtmlString,
      createScript: () => '',
      createScriptURL: sanitizeScriptUrl,
    });
  } catch {
    // Policy may already exist.
  }
};

